import { useEffect, useState } from "react";
import "./toast.css";
import toastIcon from "../../assets/icons/toastIcon.svg";

export default function Toast({ toast }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="toast-container">
      <img src={toastIcon} alt="toast icon" />
      <div className="toast-message">
        <h1>{toast.header}</h1>
        <p>{toast.message}</p>
      </div>
    </div>
  );
}
